/**
 * Smoothly scrolls to a section by ID with offset compensation
 */
export const scrollToSection = (sectionId: string) => {
  // First check if we need to navigate to home page
  const isHomePage = window.location.pathname === '/';
  if (!isHomePage) {
    window.location.href = `/#${sectionId}`;
    return;
  }
  
  const section = document.getElementById(sectionId);
  
  if (section) {
    const headerHeight = 100; // Increased offset to account for fixed header
    const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    
    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth'
    });
  }
};